import { useRef, useCallback } from 'react'
import { collapseRepeatedPhrases, mergeFinalSegments } from '../utils/textSanitize'

export interface OfflineDictationOptions {
  onSegment?: (text: string) => void
  onDone: (full: string) => void
  onError?: (err: string) => void
}

export function useOfflineDictation({ onSegment, onDone, onError }: OfflineDictationOptions) {
  const recRef = useRef<any>(null)
  const fullRef = useRef<string>('')
  const interimRef = useRef<string>('')

  const start = useCallback(() => {
    const SR = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition
    if (!SR) {
      onError?.('Brak lokalnego rozpoznawania mowy')
      return
    }
    const rec = new SR()
    rec.lang = 'pl-PL'
    rec.continuous = true
    rec.interimResults = true
    recRef.current = rec
    fullRef.current = ''
    interimRef.current = ''

    rec.onresult = (e: any) => {
      const finals: string[] = []
      let interim = ''
      for (let i = 0; i < e.results.length; i++) {
        const t = e.results[i][0].transcript
        if (e.results[i].isFinal) {
          finals.push(t)
        } else {
          interim = t
        }
      }
      const full = mergeFinalSegments(finals)
      fullRef.current = full
      interimRef.current = interim
      onSegment?.(full + (interim ? ' ' + interim : ''))
    }

    rec.onerror = (e: any) => { onError?.(e.error || 'SR error') }
    rec.onend = () => {
      const full = (fullRef.current + (interimRef.current ? ' ' + interimRef.current : '')).trim()
      onDone(collapseRepeatedPhrases(full))
      recRef.current = null
    }

    try { rec.start() } catch (err: any) { onError?.(err.message || 'SR start error') }
  }, [onSegment, onDone, onError])

  const stop = useCallback(() => {
    if (recRef.current) {
      try { recRef.current.stop() } catch (_) {}
      recRef.current = null
    }
  }, [])

  return { start, stop }
}
